<script>
    import ChangeLogsFormatted from "../../PatientEncounter/components/ChangeLogsFormatted.svelte";

    export let data = {};

    let isShowResponse = true;

    // HELPER FUNCTIONS
    const _toggleShowHideDetails = () => (isShowResponse = !isShowResponse);
</script>

<div
    class={`transition flex flex-col w-full lg:flex-row ${
        isShowResponse ? "" : "max-h-[50px]"
    }`}
>
    <div
        class="flex-1 h-full card bg-white rounded-box border"
    >
        <div
            class="flex justify-between pr-4 text-white cursor-pointer bg-gradient-to-b from-bg-primary to-bg-secondary"
            on:click|preventDefault={_toggleShowHideDetails}
        >
            <p class="font-bold px-2 py-4">Changes</p>
        </div>

        <div class="px-6 py-3">
            <ChangeLogsFormatted row={data} fullWidthDisplay />
        </div>
    </div>
</div>

<style>
    .content {
        width: calc(100% - 50px);
    }

    .transition {
        transition: 0.5s linear;
    }
</style>
